import React from 'react'
import PropTypes from 'prop-types'
import theme from 'styles/theme'
import { Eyebrow } from 'components/Typography'
import FormLabel from '../FormLabel'
import FormErrorMessage from '../FormErrorMessage'
import FormHelpLabel from '../FormHelpLabel'
import { Wrapper, InputDropdown } from './FormDropdown.style'

const FormDropdown = ({
  errorMessage,
  handleChange,
  hasError,
  helpLabel,
  isDisabled,
  label,
  name,
  options,
  required,
  value,
  uppercase,
  ...rest
}) => {
  return (
    <Wrapper>
      <FormLabel hasError={hasError} isDisabled={isDisabled}>
        {label && (
          <Eyebrow color={theme.colors.sagedark}>
            {label}
            {!!helpLabel && <FormHelpLabel>{helpLabel}</FormHelpLabel>}
          </Eyebrow>
        )}

        <InputDropdown
          value={value}
          name={name}
          onChange={handleChange}
          required={required}
          hasError={hasError}
          isDisabled={isDisabled}
          fixedSize={rest.fixedSize}
          centerLabels={rest.centerLabels}
          uppercase={uppercase}>
          {options &&
            options.map((option, index) => {
              const key = `option_${index}`

              return (
                <option
                  key={key}
                  value={option.value}
                  disabled={option.isDisabled && option.isDisabled}>
                  {option.name}
                </option>
              )
            })}
        </InputDropdown>

        {hasError && <FormErrorMessage errorMessage={errorMessage} />}
      </FormLabel>
    </Wrapper>
  )
}

FormDropdown.propTypes = {
  errorMessage: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  helpLabel: PropTypes.string,
  isDisabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  uppercase: PropTypes.bool,
}

FormDropdown.defaultProps = {
  errorMessage: '',
  hasError: false,
  helpLabel: '',
  isDisabled: false,
  required: false,
  value: '',
  uppercase: false,
}

export default FormDropdown
